import React, { Component } from 'react';
import NavBar from '../layout/NavBar';
import csvParse from 'csv-parse/lib/sync';
import ResultModal from '../common/modal/ResultModal';
import {
  OuterComponent,
} from './StyledComponent';
import { Button } from 'reactstrap';
import OnlineConsultConfirmModal from './OnlineConsultConfirmModal';
import LoadingComponentAbsolute from '../common/LoadingComponentAbsolute';
import { onlineConsultationBooking } from '../../services/api/online-consultation-booking';
import Select from 'react-select';
import { fetchAllSponsors } from '../../services/api/sponsors';
import ConsultOnlineModal from '../common/modal/consultOnlineModal';
import DependentModal from '../common/modal/dependentModal';
// import OpdHolderTable from './OpdHolderTable';
// import UpdateOpdMembersTable from './UpdateOpdMembersTable';

const newConsultationUserCols = ['Name', 'DoctorId', 'MobileNo', 'Dob', 'Email', 'Platform', 'Gender', 'Relation', 'MemberId', 'PolicyNumber'];

const sampleFileUrl =
  'https://visit-public.s3.ap-south-1.amazonaws.com/operations-dashboard/add-opd-members-sample.csv';

class OnlineConsultationBooking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      showModal: false,
      showOnlineConfirmModal: false,
      summary: [],
      premium: '',
      modalHeader: '',
      modalBody: '',
      bgColor: '',
      data: [],
      tableData: [],
      submitId: '',
      sponsorId: null,
      showUpdateTable: false,
      selectedOption: null,
      showOpdTable: true,
      invalidRecord: [],
      columnsNames: [],
      sponsors: [],
      records: [],
      search: '',
      pageSize: 10,
      pages: 0,
      filtered: [],
      bookConsultModal:false,
      addDependentModal:false,
      consultationPayType: 'wallet'
    };
  }
  componentDidMount = () => {
    this.getSponsors();
  };
  getSponsors = () => {
    return fetchAllSponsors()
      .then((response) => {
        console.log(response, 'Response from server');
        const sponsors = response.data.map((sponsor) => {
          return {
            value: sponsor.sponsorId,
            label: sponsor.sponsorName,
          };
        });
        this.setState({
          sponsors,
        });
      })
      .catch(() => {
        this.setState({
          sponsors: [],
        });
      });
  };
  // Check the data parse
  // Onboard New Members
  checkOnboardData = (data) => {
    // console.log(data.length, '[checkOnboardData]');
    const columnsNames = data.shift();
    console.log(columnsNames, '[columnNames]');
    const records = data;
    if (this.state.sponsorId) {
      if (columnsNames.length === newConsultationUserCols.length) {
        // console.log(records, 'records');
        let columnMatch = true,
          message = '';
        for (let i = 0; i < columnsNames.length; i++) {
          if (columnsNames[i] !== newConsultationUserCols[i]) {
            columnMatch = false;
            message = `Column name doesn't match. Expected column name ${newConsultationUserCols[i]} get ${columnsNames[i]}`;
          }
        }
        if (columnMatch) {
          const isFree = this.state.consultationPayType == 'wallet' ? false : true;
          onlineConsultationBooking(columnsNames, records, this.state.sponsorId, isFree)
            .then((resp) => {
              console.log({ resp }, 'onlineConsultationBooking');
              this.setState({
                showOnlineConfirmModal: true,
                modalHeader: 'Success',
                invalidRecord: resp.invalidRecord,
              });
            })
            .catch((err) => {
              let errorMessage = err.message;
              if (err.response !== undefined) {
                errorMessage = err.response.data.errorDebug;
              }
              // console.log(errorMessage);
              this.setState({
                showModal: true,
                modalHeader: 'Parsing Failed',
                modalBody: `Error : "${errorMessage}". Check the csv file and try again.`,
                bgColor: 'bg-danger',
              });
            });
        } else {
          this.setState({
            showModal: true,
            modalHeader: 'Parsing Failed',
            modalBody: `Error : ${message}`,
            bgColor: 'bg-danger',
          });
        }
      } else {
        this.setState({
          showModal: true,
          modalHeader: 'Parsing Failed',
          modalBody:
            'Error : columns length of csv file is not equal to the required format. Check the csv format and try again',
          bgColor: 'bg-danger',
        });
      }
    } else {
      this.setState({
        showModal: true,
        modalHeader: 'Warning',
        modalBody: 'Please select sponsor first.',
        bgColor: 'bg-warning',
      });
    }
  };
  handleOnboard = () => {
    document.querySelector('#csvOnboardingAttachment').click();
  };
  handleOnboardAttachment = () => {
    const file = document.querySelector('#csvOnboardingAttachment').files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const res = reader.result;
      // console.log({ res });

      try {
        const data = csvParse(res, {
          // columns: true,
          skip_empty_lines: true,
          quote: '"',
          ltrim: true,
          rtrim: true,
          delimiter: ',',
        });
        // console.log({ data });
        this.setState({ data: data });
        console.log(this.state.data, 'dataaas');
        this.checkOnboardData(data);
      } catch (err) {
        // console.log(err.message, 'err in parse');
        this.setState({
          showModal: true,
          modalHeader: 'Failed',
          modalBody: err.message,
          bgColor: 'bg-danger',
        });
      }
    };
    reader.readAsText(file);
    document.querySelector('#csvOnboardingAttachment').value = null;
  };
  // Update Member Details
  handleUpdate = () => {
    document.querySelector('#csvUpdateAttachment').click();
  };
  handleUpdateAttachment = () => {
    const file = document.querySelector('#csvUpdateAttachment').files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const res = reader.result;
      // console.log({ res });

      try {
        const data = csvParse(res, {
          // columns: true,
          skip_empty_lines: true,
          quote: '"',
          ltrim: true,
          rtrim: true,
          delimiter: ',',
        });
        const tableData = csvParse(res, {
          columns: true,
          skip_empty_lines: true,
          quote: '"',
          ltrim: true,
          rtrim: true,
          delimiter: ',',
        });
        // console.log({ data, tableData });
        this.setState({ data: data });
        // console.log(this.state.data, 'dataaas');
        this.checkUpdateData(data, tableData);
      } catch (err) {
        // console.log(err.message, 'err in parse');
        this.setState({
          showModal: true,
          modalHeader: 'Failed',
          modalBody: err.message,
          bgColor: 'bg-danger',
        });
      }
    };
    reader.readAsText(file);
    document.querySelector('#csvUpdateAttachment').value = null;
  };
  handleChange = (event) => {
    console.log({ event });
    console.log('data', this.sta);
    this.setState({ sponsorId: event.value, selectedOption: event });
  };

  openBookConsultModal = () => {
    console.log('check  ')
    this.setState({
      bookConsultModal:true
    })
  }

  addDependentModal = () =>{
    this.setState({
      addDependentModal:true
    })
  }
  handleConsultationPayType = (type) => {
    this.setState({
      consultationPayType: type
    });
  };

  render() {
    return (
      <OuterComponent>
        <NavBar />

        {/* Page Header */}
        <div
          style={{
            marginTop: '4rem',
            padding: '20px 24px 16px',
            backgroundColor: '#fff',
            borderBottom: '2px solid #e5e7eb',
          }}
        >
          <h4 style={{ margin: 0, fontWeight: 600, color: '#1f2937' }}>
            Online Consultation Booking
          </h4>
          <p style={{ margin: '6px 0 0', fontSize: '13px', color: '#6b7280' }}>
            For partners like Axis Bank. Upload a CSV with columns: Name, DoctorId, MobileNo, Dob, Email, Platform, Gender, Relation, MemberId (optional), PolicyNumber (optional).
          </p>
        </div>

        {/* Controls Panel */}
        <div
          style={{
            padding: '16px 24px',
            backgroundColor: '#f9fafb',
            borderBottom: '1px solid #e5e7eb',
          }}
        >
          {/* Row 1: Sponsor + Pay Type */}
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '24px', flexWrap: 'wrap' }}>
            {/* Sponsor Select */}
            <div style={{ minWidth: 240, width: 280 }}>
              <label style={{ fontSize: '11px', fontWeight: 600, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '5px', display: 'block' }}>
                Sponsor
              </label>
              <Select
                onChange={this.handleChange}
                options={this.state.sponsors}
                placeholder="Select sponsor..."
                value={this.state.selectedOption}
                styles={{
                  control: (base) => ({ ...base, fontSize: '13px', minHeight: '36px' }),
                  option: (base) => ({ ...base, fontSize: '13px' }),
                }}
              />
            </div>

            {/* Pay Type */}
            <div>
              <label style={{ fontSize: '11px', fontWeight: 600, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px', display: 'block' }}>
                Payment Type
              </label>
              <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#374151', cursor: 'pointer', margin: 0 }}>
                  <input
                    type="radio"
                    name="consultationPayType"
                    checked={this.state.consultationPayType === 'wallet'}
                    onChange={() => this.handleConsultationPayType('wallet')}
                  />
                  Wallet
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#374151', cursor: 'pointer', margin: 0 }}>
                  <input
                    type="radio"
                    name="consultationPayType"
                    checked={this.state.consultationPayType === 'free'}
                    onChange={() => this.handleConsultationPayType('free')}
                  />
                  Free
                </label>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div style={{ borderTop: '1px solid #e9ecef', margin: '14px 0' }} />

          {/* Row 2: Action Buttons */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <input
              type="file"
              id="csvOnboardingAttachment"
              accept=".csv"
              style={{ display: 'none' }}
              onChange={this.handleOnboardAttachment}
            />
            <Button
              color="primary"
              size="sm"
              style={{ borderRadius: '5px', padding: '7px 18px', fontSize: '13px' }}
              onClick={this.handleOnboard}
            >
              Bulk Booking
            </Button>
            <Button
              color="info"
              size="sm"
              style={{ borderRadius: '5px', padding: '7px 18px', fontSize: '13px' }}
              onClick={() => this.openBookConsultModal()}
            >
              Book Online Consult
            </Button>
            <Button
              color="secondary"
              size="sm"
              style={{ borderRadius: '5px', padding: '7px 18px', fontSize: '13px' }}
              onClick={() => this.addDependentModal()}
            >
              Add Dependent
            </Button>
          </div>
        </div>

        {/* Modals */}
        {this.state.showOnlineConfirmModal && (
          <OnlineConsultConfirmModal
            modalHeader={this.state.modalHeader}
            closeModal={() =>
              this.setState({ showOnlineConfirmModal: false, loading: false })
            }
            invalidRecord={this.state.invalidRecord}
          />
        )}
        {this.state.showModal && (
          <ResultModal
            modalHeader={this.state.modalHeader}
            modalBody={this.state.modalBody}
            closeModal={() => this.setState({ showModal: false })}
            bgColor={this.state.bgColor}
          />
        )}
        {this.state.bookConsultModal && (
          <ConsultOnlineModal
            openModal={this.openBookConsultModal}
            modalIsOpen={this.state.bookConsultModal}
            closeModal={() => this.setState({ bookConsultModal: false })}
          />
        )}
        {this.state.addDependentModal && (
          <DependentModal
            openModal={this.addDependentModal}
            modalIsOpen={this.state.addDependentModal}
            closeModal={() => this.setState({ addDependentModal: false })}
          />
        )}
        {this.state.loading ? <LoadingComponentAbsolute /> : null}
      </OuterComponent>
    );
  }
}

export default OnlineConsultationBooking;
